import type { TRouteObject } from "@ch/helpers/utils/types";
import AppointmentsPageLazy from "@ch/pages/AppointmentsPage";
import ErrorPage from "@ch/pages/ErrorPage";
import NotFoundPage from "@ch/pages/NotFoundPage";

const AppointmentsRoutes: TRouteObject[] = [
  {
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <AppointmentsPageLazy />,
      },
      {
        path: "*",
        element: <NotFoundPage />,
      },
    ],
  },
];

export default AppointmentsRoutes;
